<template>
  <div class="login-block">
    <div class="grid-content form" @keyup.enter="login()">
      <el-form ref="form" :model="loginForm" class="signupForm">
        <el-form-item label="Email/Username" class="label150">
          <el-input
            placeholder="Username or email address..."
            name="username"
            v-model="loginForm.username"
            required
            size="medium"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
          ></el-input>

          <el-alert v-for="e in loginForm.errors.username" :title="e" type="error" :key="e"></el-alert>
        </el-form-item>
         <el-alert v-for="e in loginForm.errors.email" :title="e" type="error" :key="e"></el-alert>

        <el-form-item label="Password" class="label150">
          <el-input
            placeholder="Password..."
            name="password"
            v-model="loginForm.password"
            required
            size="medium"
            :type="showPassword ? 'text' : 'password'"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
          ></el-input>

          <el-alert v-for="e in loginForm.errors.password" :title="e" type="error" :key="e"></el-alert>
        </el-form-item>

        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <a class="el-button el-button--text" style="width: 100%"
                 href="/password/reset">Forgotten password?</a>
            </el-col>
            <el-col :span="12">
              <el-button @click="login" style="width: 100%" class="submitButton" type="primary">Login</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="7">

            </el-col>
            <el-col :span="7" :offset="2">
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// @keyup.enter="register"
import Helpers from "../../mixins/Helpers";
import VueRecaptcha from "vue-recaptcha";
import GoogleLoginButton from "../GoogleLoginButton";

export default {
  mixins: [Helpers],

  components: { GoogleLoginButton, VueRecaptcha },

  props: ["visible"],

  data() {
    return {
      loading: false,
      showPassword: false,
      recaptchaKey: window.Laravel.recaptchaKey,

      registerForm: {
        username: "",
        password: "",
        password_confirmation: "",
        email: "",
        errors: [],
        reCAPTCHA: ""
      },

      loginForm: {
        username: "",
        password: "",
        errors: [],
        remember: true
      }
    };
  },

  methods: {
    reCaptchaVerified(response) {
      this.registerForm.reCAPTCHA = response;
    },

    reCaptchaExpired() {
      this.registerForm.reCAPTCHA = "";
    },

    login() {
      this.loading = true;

      axios
        .post(`${Laravel.url}/login`, {
          username: this.loginForm.username,
          password: this.loginForm.password,
          remember: this.loginForm.remember
        })
        .then(response => {
          this.loading = false;
          this.loginForm.errors = [];
          Vue.clearLS();

          history.go(-1);

          setInterval(function() {
            location.reload();
          }, 1000);
        })
        .catch(error => {
          this.loading = false;
          this.loginForm.errors = error.response.data.errors;
        });
    },

    register() {
      this.loading = true;

      axios
        .post(`${Laravel.url}/register`, {
          username: this.registerForm.username,
          email: this.registerForm.email,
          password: this.registerForm.password,
          password_confirmation: this.registerForm.password_confirmation,
          "g-recaptcha-response": this.registerForm.reCAPTCHA
        })
        .then(response => {
          this.loading = false;
          this.registerForm.errors = [];
          window.location = "/discover-channels?newbie=1&sidebar=0";
        })
        .catch(error => {
          this.loading = false;
          // this.$refs.recaptcha.reset();
          this.registerForm.errors = error.response.data.errors;
        });
    }
  }
};
</script>

<style scoped>
.well {
  border-right: black 1px solid;
  padding: 20px;
}

.form {
  text-align: right;
  padding-top: 20px;
}

.columm {
  margin-bottom: 20px;
}

.signup {
  padding: 20px 0;
  border-radius: 5px;
  width: 320px;
}

.text-center {
  text-align: center;
}

.signupForm {
      width: 75%;
      margin: auto;
  }
  .label150{
      label-width:150px;
  }
  @media (max-width: 900px) {
      .signupForm {
      width: 100%;
  }
      .label150{
      label-width:5px;
  }
  }

.facebook {
  background: #3b5898;
  color: white;
}

.login-block {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/Authentication.vue